import Constants from '@/Constants';
import React, { ChangeEvent, useEffect, useState } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import './style.scss';

interface Props {
    buttonBar?: boolean;
    disabled?: boolean;
    readonly?: boolean;
    max?: number;
    min?: number;
    step?: number;
    initial?: number;
    whenDisabledSetValueTo?: number;
    hideValueIfDisabled?: boolean;
    onChange: CallableFunction;
    label: string;
    tooltip?: string;
    style?: React.CSSProperties;
    info?: string;
}

const InputNumberSpinner: React.FC<Props> = (props: Props) => {
    const {
        buttonBar = false,
        disabled = false,
        readonly = false,
        max = 100,
        min = 0,
        step = 1,
        initial = min,
        onChange,
        whenDisabledSetValueTo,
        hideValueIfDisabled = false,
        label,
        tooltip,
        style,
        info,
    } = props;

    const [value, setValue] = useState<number>(initial);

    const btValues = [5, 10, 30, 60];

    useEffect(() => {
        onChange(value);
    }, [value]);

    useEffect(() => {
        if (disabled && whenDisabledSetValueTo != undefined) {
            setValue(whenDisabledSetValueTo);
        }
    }, [disabled]);

    useEffect(() => {
        setValue(initial);
    }, [initial]);

    const decrementHandler = (valueButton: number) => {
        setValue(value - valueButton >= min ? value - valueButton : min);
    };

    const incrementHandler = (valueButton: number) => {
        setValue(value + valueButton <= max ? value + valueButton : max);
    };

    const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
        setValue(Number(e.target.value));
    };

    return (
        <div className="input-number-spinner input-section" style={style}>
            <div className="field-title-container">
                <h1>{label} </h1>
                {tooltip && (
                    <span>
                        <OverlayTrigger overlay={<Tooltip id="evaluation_weight_hint">{tooltip}</Tooltip>} placement="bottom">
                            <i className="material-icons-outlined align-middle hint">{Constants.icons.ERROR_OUTLINE}</i>
                        </OverlayTrigger>
                    </span>
                )}
            </div>
            <div className="field-container">
                <div className="quantity">
                    <div className={`quantity-nav input-section ${disabled || readonly ? 'disabled' : ''}`}>
                        <div className="quantity-button quantity-up ">
                            <span className="material-icons-outlined align-middle" onClick={() => !disabled && !readonly && incrementHandler(step)}>
                                {Constants.icons.CIRCLE_PLUS}
                            </span>
                        </div>
                        <div className="quantity-button quantity-down ">
                            <span className="material-icons-outlined align-middle" onClick={() => !disabled && !readonly && decrementHandler(step)}>
                                {Constants.icons.CIRCLE_MINUS}
                            </span>
                        </div>
                        <input
                            className={`quantity-input ${disabled && hideValueIfDisabled ? 'hide' : ''}`}
                            disabled={disabled || readonly}
                            max={max}
                            min={min}
                            onChange={handleOnChange}
                            step={step}
                            type="number"
                            value={value}
                        />
                    </div>
                    {buttonBar && (
                        <div className={`quantity-button-bar ${disabled || readonly ? 'disabled' : ''}`}>
                            {btValues.map((bt: number, index: number) => {
                                return (
                                    <div className="quantity-buttons" key={index} onClick={() => !disabled && !readonly && incrementHandler(bt)}>
                                        +{bt}
                                    </div>
                                );
                            })}
                        </div>
                    )}
                    {info && <span className="field-info">{info}</span>}
                </div>
            </div>
        </div>
    );
};

export default InputNumberSpinner;
